module.exports = __webpack_public_path__ + "img/4-1.471337a8.svg";